import React from "react";

const Index = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="25"
        viewBox="0 0 30 25"
        fill="none"
      >
        <path
          d="M9.16016 23.5L26.1602 23.5C27.2647 23.5 28.1602 22.6046 28.1602 21.5L28.1602 8.5C28.1602 7.39543 27.2647 6.5 26.1602 6.5L9.16016 6.5C8.05559 6.5 7.16016 7.39543 7.16016 8.5L7.16016 21.5C7.16016 22.6046 8.05559 23.5 9.16016 23.5Z"
          stroke="#EEEEF1"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.16016 18.5V3.5C2.16016 2.96957 2.37087 2.46086 2.74594 2.08579C3.12102 1.71071 3.62972 1.5 4.16016 1.5H22.1602"
          stroke="#EEEEF1"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.36017 23.34L16.2202 15.04C16.4061 14.8358 16.6323 14.6722 16.8845 14.5596C17.1368 14.4471 17.4096 14.388 17.6858 14.3862C17.962 14.3843 18.2356 14.4396 18.4893 14.5487C18.7431 14.6578 18.9715 14.8183 19.1602 15.02L27.0602 23.3"
          stroke="#EEEEF1"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export default Index;
